import { RowItemData } from "../../components/datatable/interfaces";
import { BatchAnalysisStatus } from "../../generated/VideoAnalysis";
import { dateService } from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";


export class BatchAnalysisStatusItem implements RowItemData {
  id: number;
  videoId: number;
  private objectId: number;
  private objectName: string;
  private projectName: string;
  private inspectionDate: Date;
  private status: BatchAnalysisStatus;

  constructor(item: any) {
    this.id = item.videoId;
    this.videoId = item.videoId;
    this.objectId = item.objectId;
    this.objectName = item.objectName;
    this.projectName = item.projectName;
    this.inspectionDate = item.inspectionDate;
    this.status = item.initialStatus
  }

  get displayValues() {
    return {
      object: { toDisplay: this.objectName },
      inspection: { toDisplay: dateService.formatDate(this.inspectionDate) },
      status: {
        toDisplay: translationService.translate(`damages.BatchProcessingStatus.batchResults.status.${BatchAnalysisStatus[this.status]}`),
        className: this.status === BatchAnalysisStatus.PartiallyFailed || this.status === BatchAnalysisStatus.Failed
          ? "error"
          : this.status === BatchAnalysisStatus.Successfully ? "success" : undefined
      },
    };
  }
}
